module.exports = __webpack_public_path__ + "36826dc540414a328575eae23f1b266c.pdf";